<template>
  <footer>
    <base-row>
      <base-column class="d-flex justify-content-between align-content-center">
        <p>Copyright © 2022 <router-link class="portfolio" to="home">Portfolio</router-link>. All Rights Reserved</p>
        <ul class="my-auto">
          <li><a :href="github"><base-icon icon="github" :width="1.2" :height="1.2"></base-icon></a></li>
          <li><a :href="linkedin"><base-icon icon="linkedin-original" :width="1.2" :height="1.2"></base-icon></a></li>
          <li><a :href="twitter"><base-icon icon="twitter-original" :width="1.2" :height="1.2"></base-icon></a></li>
          <li><a :href="gmail"><base-icon icon="gmail" :width="1.2" :height="1.2"></base-icon></a></li>
        </ul>
      </base-column>
    </base-row>
  </footer>
</template>

<script>
import BaseIcon from "../base/BaseIcon";
export default {
  name: "TheFooter",
  components: {BaseIcon},
  computed: {
    gmail() {
      return this.$store.getters['contact/getGmail'];
    },
    linkedin() {
      return this.$store.getters['contact/getLinkedin'];
    },
    github() {
      return this.$store.getters['contact/getGithub'];
    },
    twitter() {
      return this.$store.getters['contact/getTwitter']
    }
  }
}
</script>

<style scoped>
p {
  margin: auto 0;
  padding: 0;
}

a,a:visited,a:hover {
  text-decoration: none;
}

li {
  display: inline;
  padding: 0 .4rem;
}
footer {
  background-color : #f5f5f5;
  padding: 1rem 0;
}

.portfolio {
  color: #f6483b;
  font-weight: bold;
}
</style>